import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Ticker } from "@/components/sections/ChartMotif";
import { About } from "@/components/sections/About";
import { Journey } from "@/components/sections/Journey";
import { Philosophy } from "@/components/sections/Philosophy";
import { Values } from "@/components/sections/Values";
import { Lessons } from "@/components/sections/Lessons";
import { Insights } from "@/components/sections/Insights";
import { Success } from "@/components/sections/Success";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    const onAnchor = (e) => {
      const a = e.target.closest("[data-scroll-to]");
      if (a) {
        e.preventDefault();
        const target = document.querySelector(a.getAttribute("data-scroll-to"));
        if (target) lenis.scrollTo(target, { offset: -10 });
      }
    };
    document.addEventListener("click", onAnchor);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      delete window.__lenis;
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-ink text-bone antialiased selection:bg-gold selection:text-ink">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#161616",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F4F4F0",
            borderRadius: 0,
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <About />
        <Journey />
        <Philosophy />
        <Marquee />
        <Values />
        <Lessons />
        <Insights />
        <Success />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
